const resources = {
    title: 'Clavardage beauté IA',
    placeholder: 'Message...',
    shareFeedback: 'Partagez votre avis',
    new: 'NOUVEAUTÉ',
    addToBasket: 'Ajouter au panier',
    size: 'Format',
    errorMessage: 'Un problème est survenu. Essayez de redémarrer le clavardage ou',
    resendYourMessage: 'renvoyez votre message',
    addToBasketErrorTitle: 'Un problème est survenu',
    addToBasketErrorMessage: 'Nous n’avons pas pu ajouter cet article à votre panier. Veuillez essayer de nouveau.',
    ok: 'OK',
    lookingForAGift: 'Je cherche un cadeau!',
    startChat: 'Démarrez une séance de clavardage',
    tryAsking: 'Essayez de demander',
    topHairCareQuestions: 'Questions les plus fréquentes sur les soins capillaires',
    topSkincareQuestions: 'Questions les plus fréquentes sur les soins de la peau',
    topMakeupQuestions: 'Questions les plus fréquentes sur le maquillage',
    topFragranceQuestions: 'Questions les plus fréquentes sur les parfums',
    topBathBodyQuestions: 'Questions les plus fréquentes sur les essentiels pour le bain et le corps',
    description: 'Soutenu par des millions d’évaluations, des renseignements exclusifs sur les articles et vos préférences personnelles en matière de beauté.',
    welcomeBack: 'C’est bon de vous revoir!',
    feedback: 'Avis',
    added: 'Ajouté',
    free: 'GRATUIT',
    points: 'Points',
    purchasedOn: 'ACHETÉ LE',
    color: 'Couleur :',
    shade: 'Teinte :',
    variant: 'Variante :',
    viewAll: 'Tout afficher',
    carouselLabel: 'Carrousel des promotions',
    carouselPrevious: 'Promotions passées',
    carouselNext: 'Prochaines promotions',
    fromCustomerReviews: 'D’après les évaluations de membres de la clientèle :',
    customerReviewSentiments: 'Sentiments exprimés par les commentaires des clients',
    positiveSentiment: 'Positifs',
    negativeSentiment: 'Négatifs',
    positiveReviewsMentioning: 'Commentaires positifs mentionnant',
    negativeReviewsMentioning: 'Commentaires négatifs mentionnant',
    sentimentQueryFor: 'pour',
    newChat: 'Nouvelle conversation',
    whyRecommended: 'Pourquoi cet essentiel a-t-il été recommandé?',
    in: 'dans',
    loadingChatPrompts: 'Chargement des invites de clavardage',
    productsUnavailable: 'Nous n’avons pas pu charger les recommandations d’articles.',
    promotionsUnavailable: 'Nous n’avons pas pu charger les promotions.',
    responseUnavailable: 'Nous n’avons pas pu charger une partie de cette réponse.',
    nextPage: 'Page suivante',
    previousPage: 'Page précédente',
    shadeMatch: 'Correspondance de teinte',
    orderPickupAtStore: 'at {0}',
    orderShipmentCount: 'Shipment {0} of {1}',
    orderDeliveryEstimatePending: 'Delivery estimate pending',
    orderArrivingDate: 'Arriving {0}',
    orderDeliveredDate: 'Delivered {0}',
    orderEstimatedByTime: '{0}, by {1}',
    connectWithCustomerService: 'Connect with Customer Service'
};

export default function getResource(label) {
    return resources[label];
}
